import React from "react";
import { useTranslation } from "react-i18next";

const Disclaimer = () => {
  const { t } = useTranslation();

  return (
    <div className="page">
    <div className="h-10" />
    <div className="w-full h-px bg-gray-800" />
      <div className="page">
        <div className="w-full p-5 mb-10">
          <div className="text-international mb-2">{t("glossary")}</div>
          <div className="ml-2 text-avgStay text-sm glos">
            <div
              dangerouslySetInnerHTML={{
                __html: t("hosting")
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos1")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos2")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos3")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos4")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos5")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos6")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos7")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos12")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos8")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos9")
              }}
            />
            <br />
            <div
              dangerouslySetInnerHTML={{
                __html: t("glos10")
              }}
            />
            <br />
          </div>
        </div>
      </div>
      <div className="w-full p-5 mb-10">
        <div className="text-international mb-2">{t("glossary")}</div>
        <div className="ml-2 text-avgStay text-sm glos">
          <div
            dangerouslySetInnerHTML={{
              __html: t("glos11")
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t("glos12")
            }}
          />
          <br />
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
